import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Person_Foau_Mutation = graphql(`
  mutation ThirdPartyForm_Person_Foau(
    $filter: IdFilterInput!
    $update: PersonInput!
    $versionData: VersionDataInput
  ) {
    findOneAndUpdatePerson(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type ThirdPartyForm_Person_Foau_Result = ResultOf<
  typeof ThirdPartyForm_Person_Foau_Mutation
>;

export const useUpdatePersonMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Person_Foau_Mutation);
